import React from 'react';
const bonuses = [{
  num: '01',
  emoji: '⚖️',
  title: 'Solucionario de Cargas',
  desc: 'Cuánta intensidad aplicar según el día de la semana.',
  value: '$9'
}, {
  num: '02',
  emoji: '📅',
  title: 'Plan de Temporada Express',
  desc: 'Hoja de ruta para organizar tu pretemporada y torneo.',
  value: '$12'
}, {
  num: '03',
  emoji: '✅',
  title: 'Kit de Verificación Técnica',
  desc: 'Checklists para evaluar el gesto técnico de tus jugadores.',
  value: '$7'
}, {
  num: '04',
  emoji: '🎧',
  title: 'Charlas de Vestuario',
  desc: 'Guía de comunicación efectiva para motivar a tu equipo.',
  value: '$7'
}, {
  num: '05',
  emoji: '🏆',
  title: 'Diplomas de Evolución',
  desc: 'Para premiar el esfuerzo de los más pequeños (fidelización infantil).',
  value: '$7'
}, {
  num: '06',
  emoji: '🤝',
  title: 'Kit de Adaptación',
  desc: 'Variaciones de ejercicios para grupos con niveles muy dispares.',
  value: '$7'
}];
export function BonusSection() {
  return <section className="w-full bg-bg-main py-20 sm:py-28 px-4 relative overflow-hidden" data-id="element-26">
      {/* Decorative background glows */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[700px] h-[400px] bg-secondary/8 rounded-full blur-[140px] pointer-events-none" data-id="element-27"></div>
      <div className="absolute bottom-0 right-0 w-[400px] h-[400px] bg-secondary/6 rounded-full blur-[120px] pointer-events-none" data-id="element-28"></div>

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-29">
        {/* Eyebrow */}
        <div className="flex items-center justify-center gap-3 mb-5" data-id="element-30">
          <span className="h-px w-8 sm:w-12 bg-gradient-to-r from-transparent to-secondary/60" data-id="element-31"></span>
          <p className="text-secondary font-bold text-sm sm:text-base tracking-[0.2em] uppercase whitespace-nowrap" data-id="element-32">
            🔥 Regalos exclusivos
          </p>
          <span className="h-px w-8 sm:w-12 bg-gradient-to-l from-transparent to-secondary/60" data-id="element-33"></span>
        </div>

        <h2 className="text-3xl sm:text-5xl font-black text-text-main mb-4 text-center tracking-tight leading-tight" data-id="element-34">
          6 Bonos Especiales{' '}
          <span className="relative inline-block" data-id="element-35">
            <span className="relative z-10 text-secondary" data-id="element-36">Incluidos</span>
            <span className="absolute bottom-1 left-0 right-0 h-2 sm:h-3 bg-secondary/20 -z-0 rounded-sm" data-id="element-37"></span>
          </span>
        </h2>

        {/* Value strip */}
        <div className="flex items-center justify-center gap-3 mb-12 sm:mb-14 flex-wrap" data-id="element-38">
          <span className="text-text-sec text-base sm:text-lg font-medium" data-id="element-39">
            Valor combinado:
          </span>
          <span className="text-text-sec line-through text-lg sm:text-xl font-bold" data-id="element-40">
            $49
          </span>
          <span className="bg-gradient-to-r from-secondary to-yellow-400 text-bg-dark px-3 py-1 rounded-full text-xs sm:text-sm font-black tracking-wider shadow-[0_0_15px_rgba(245,158,11,0.4)]" data-id="element-41">
            GRATIS HOY
          </span>
        </div>

        <div className="space-y-3 sm:space-y-4" data-id="element-42">
          {bonuses.map((bonus, i) => <div key={i} className="group relative bg-bg-alt/80 backdrop-blur-sm rounded-2xl border border-border-light p-5 sm:p-6 flex items-center gap-4 sm:gap-5 transition-all duration-300 hover:-translate-y-1 hover:border-secondary/50 hover:shadow-[0_15px_40px_rgba(245,158,11,0.15)] overflow-hidden" data-id="element-43">
              {/* Hover gradient overlay */}
              <div className="absolute inset-0 bg-gradient-to-r from-secondary/0 via-secondary/0 to-secondary/5 opacity-0 group-hover:opacity-100 transition-opacity duration-500 pointer-events-none" data-id="element-44"></div>

              {/* Left accent bar on hover */}
              <span className="absolute left-0 top-0 bottom-0 w-1 bg-gradient-to-b from-secondary to-yellow-400 scale-y-0 group-hover:scale-y-100 origin-top transition-transform duration-300" data-id="element-45"></span>

              {/* Number badge */}
              <span className="hidden sm:flex flex-shrink-0 text-2xl font-black text-secondary/30 group-hover:text-secondary/70 transition-colors w-10 tracking-tight" data-id="element-46">
                {bonus.num}
              </span>

              {/* Emoji icon */}
              <div className="w-14 h-14 sm:w-16 sm:h-16 rounded-xl bg-gradient-to-br from-secondary/25 to-secondary/5 border border-secondary/30 flex items-center justify-center flex-shrink-0 text-2xl sm:text-3xl shadow-inner group-hover:scale-110 group-hover:rotate-3 transition-transform duration-300 relative z-10" data-id="element-47">
                {bonus.emoji}
              </div>

              {/* Info */}
              <div className="flex-1 min-w-0 relative z-10" data-id="element-48">
                <div className="flex items-center gap-2 mb-1 sm:hidden" data-id="element-49">
                  <span className="text-xs font-black text-secondary/60 tracking-tight" data-id="element-50">
                    {bonus.num}
                  </span>
                  <span className="text-xs text-text-sec line-through font-bold" data-id="element-51">
                    {bonus.value}
                  </span>
                </div>
                <h3 className="text-text-main font-black text-lg sm:text-xl mb-0.5 tracking-tight" data-id="element-52">
                  {bonus.title}
                </h3>
                <p className="text-text-sec text-sm sm:text-base leading-relaxed" data-id="element-53">
                  {bonus.desc}
                </p>
              </div>

              {/* Right side: value + GRATIS — desktop */}
              <div className="hidden sm:flex flex-col items-end gap-1 flex-shrink-0 relative z-10" data-id="element-54">
                <span className="text-text-sec line-through text-sm font-bold" data-id="element-55">
                  {bonus.value}
                </span>
                <span className="bg-secondary/15 text-secondary border border-secondary/30 px-3 py-1.5 rounded-lg font-black text-sm shadow-[0_0_15px_rgba(245,158,11,0.2)] group-hover:bg-secondary group-hover:text-bg-dark group-hover:border-secondary transition-all" data-id="element-56">
                  GRATIS
                </span>
              </div>

              {/* GRATIS pill — mobile only */}
              <span className="sm:hidden bg-secondary/15 text-secondary border border-secondary/30 px-2.5 py-1 rounded-md font-black text-[10px] flex-shrink-0 shadow-[0_0_10px_rgba(245,158,11,0.2)] relative z-10" data-id="element-57">
                GRATIS
              </span>
            </div>)}
        </div>

        {/* Bottom emphasis */}
        <div className="mt-10 sm:mt-12 text-center bg-gradient-to-r from-secondary/10 via-secondary/15 to-secondary/10 border border-secondary/30 rounded-2xl px-6 py-5 sm:py-6 backdrop-blur-sm" data-id="element-58">
          <p className="text-text-main text-base sm:text-lg font-bold" data-id="element-59">
            🎁 Los 6 bonos se desbloquean{' '}
            <span className="text-secondary" data-id="element-60">automáticamente</span> al unirte
            hoy.
          </p>
          <p className="text-text-sec text-xs sm:text-sm mt-1" data-id="element-61">
            Sin pasos extra, sin códigos. Llegan a tu correo junto al MegaPack.
          </p>
        </div>
      </div>
    </section>;
}